<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Edit Brand</h4>
                    <p class="text-subtitle">Edit Brand</p>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="mt-2">
                <v-col cols="12" md="6">
                    <BrandForm v-model="form" ref="form"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" @click="handleCancel">
                    <v-btn depressed block>
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-3"/>
                    <v-skeleton-loader type="text" class="my-3"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="me-5"/>
                    <v-skeleton-loader type="button"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import BrandForm from './../../../components/fleet/BrandForm.vue';
import service from './../../../services/fleet/brand';
import PAlert from './../../../components/common/PAlert.vue';

export default {
    components: {
        BrandForm,
        PAlert
    },
    data() {
        return {
            form: {
                name: ""
            },
            dataLoading: false,
            loading: false,
            alert: {
                title: "Alert",
                content: "",
                callback: null,
                model: false
            },
            idempotentKey: null,
            id: null
        }
    },
    methods: {
        fetchBrand() {
            this.dataLoading = true;
            service.get(this.id).then(response => {
                let data = response.data;
                this.form = {...data}; 
            }).finally(() => {
                this.dataLoading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, model: true, content: "Are you sure you want to save?", callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            service.update(this.id, this.form).then(response => {
                this.$router.replace({ name: "BrandDisplay", params: { brandID: response.data.id } })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, model: true, content: "Are you sure you want to dicard changes?", callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.id = this.$route.params.brandID;
        this.fetchBrand()
    }
}
</script>

<style>

</style>